<template>
  <span v-bind:class="{animate: animate}">

    <span v-bind:title="stars+'/'+s.length+' '+$tc('message.star', stars)" >
      <i class="hit-glyphicon" v-for="(star, i) in s" v-bind:class="get_avg_star_class((i+1), stars)"  v-bind:key="i+'_star'" v-on:click="get_click(i+1)" v-bind:title="get_title(i+1, s.length)"></i>
    </span>

    <span class="append" v-if="append">({{ stars }})</span>
  </span>

</template>

<script>

export default{

  props: {stars: [String, Number], click: Function, append: Boolean, notEmpty: Boolean, animate: Boolean},
  data: function () {
    return {
      s: [1, 2, 3, 4, 5]
    }
  },
  methods: {

    get_title: function (i, l) {
      if (typeof this.click !== 'function') { return false }

      return i + '/' + l + ' ' + this.$tc('message.star', i)
    },
    get_click: function (i) {
      if (typeof this.click !== 'function') { return false }

      this.click(i)
    },

    get_avg_star_class: function (key, stars) {
      if (this.notEmpty === true) {
        if (key <= stars) { return {'hit-glyphicon-star': true} }

        return false
      }

      if ((key - stars) < 1 && key > stars) { return {'hit-glyphicon-star-half': true} } else if (key <= stars) { return {'hit-glyphicon-star': true} } else { return {'hit-glyphicon-star-empty': true} }
    }
  }

}

</script>

<style scoped>

  .append{
    display: inline-block;
    margin-left: 5px;
  }

  .animate i{
    animation-name: stars;
    animation-duration: 1.5s;
    opacity: 0;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-delay: 3s;
  }

  .animate i:nth-of-type(1){
    animation-delay: 1s;
  }
  .animate i:nth-of-type(2){
    animation-delay: 1.2s;
  }
  .animate i:nth-of-type(3){
    animation-delay: 1.4s;
  }
  .animate i:nth-of-type(4){
    animation-delay: 1.6s;
  }
  .animate i:nth-of-type(5){
    animation-delay: 1.8s;
  }

  @keyframes stars {
    0% {
      transform: scale(0.8);
      opacity: 0.8;
    }
    50% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.8);
      opacity: 0.8;

    }
  }

</style>
